var _classCallCheck = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Eth = require("@ledgerhq/hw-app-eth").default;

var util = require("../../util");

var _require$TierError = require("@oneledger/middle_utility").TierError,
    ErrorType = _require$TierError.ErrorType,
    ErrorUtil = _require$TierError.ErrorUtil;

var requestErrors = ErrorType.requestErrors;
var ethAddressKeyPathBase = "m/44'/60'/0'/0/";
/**
 * LedgerHQ Ethereum wallet
 */

var Ethereum =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * @description init eth wallet
   * @param transport {Object} transport object
   * Web version of transport needs to get from oneledger/ledger-sdk-web repo https://github.com/Oneledger/ledger-sdk-web
   * Node version of transport needs to get from oneledger/ledger-sdk-node repo https://github.com/Oneledger/ledger-sdk-node
   */
  function Ethereum(transport) {
    _classCallCheck(this, Ethereum);

    try {
      this.eth = new Eth(transport);
    } catch (err) {
      throw Error("failed to establish the connection to the Ethereum wallet");
    }
  }
  /**
   * @description fetch eth address with public key
   * @param keyIndex {number} non-negative integer
   * @param [boolDisplay] {boolean} enable or not the display, default is true
   * @param [boolChaincode] {boolean} enable or not the chaincode request, default is false
   */


  _createClass(Ethereum, [{
    key: "getAddrPubKey",
    value: function getAddrPubKey(keyIndex) {
      var boolDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var boolChaincode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!Number.isInteger(keyIndex) || Number(keyIndex) < 0) return Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidKeyIndex));
      return this.eth.getAddress(ethAddressKeyPathBase + keyIndex, boolDisplay, boolChaincode).then(function (response) {
        var address = response.address,
            publicKey = response.publicKey,
            chainCode = response.chainCode;
        if (address.length !== 42) return Promise.reject(Error("wallet does not match the request"));
        return Promise.resolve(ErrorUtil.responseWrap({
          address: address,
          publicKey: publicKey
        }));
      }).catch(function (err) {
        if (err.statusCode === 26368) err.message = "wallet application is not opened";
        var returnErr = requestErrors.FailToGetEthereumAddrLedgerHQ;
        returnErr.detail = "failed to get eth address: ".concat(err.message);
        return Promise.reject(ErrorUtil.errorWrap(returnErr));
      });
    }
    /**
     * @description sign eth tx
     * @param keyIndex {number} non-negative integer
     * @param rawTxHex {string} hexed raw tx with 0x prefix
     */

  }, {
    key: "signTransaction",
    value: function signTransaction(keyIndex, rawTxHex) {
      if (!Number.isInteger(keyIndex) || Number(keyIndex) < 0) return Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidKeyIndex));
      if (!util.isValidString(rawTxHex) || !rawTxHex.startsWith("0x")) return Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidETHRawTxLedgerHQ));
      return this.eth.signTransaction(ethAddressKeyPathBase + keyIndex, rawTxHex.substr(2)).then(function (response) {
        var s = response.s,
            v = response.v,
            r = response.r;
        return Promise.resolve(ErrorUtil.responseWrap({
          signature: "0x".concat(r).concat(s).concat(v)
        }));
      }).catch(function (err) {
        if (err.statusCode === 26368) err.message = "wallet application is not opened";
        var returnErr = requestErrors.FailedToSignETHTxLedgerHQ;
        returnErr.detail = "failed to sign eth tx: ".concat(err.message);
        return Promise.reject(ErrorUtil.errorWrap(returnErr));
      });
    }
  }]);

  return Ethereum;
}();

module.exports = {
  Ethereum: Ethereum
};